import { defineMessages } from 'react-intl';

export const generalFormMessages = defineMessages({
  yesResponse: {
    id: 'CreditCheckForm.YesResponse',
    defaultMessage: 'Ja',
  },
  noResponse: {
    id: 'CreditCheckForm.NoResponse',
    defaultMessage: 'Nee',
  },
  inputPlaceholder: {
    id: 'CreditCheckForm.InputPlaceholder',
    defaultMessage: "Vul hier een bedrag in hele euro's in",
  },
  totalText: {
    id: 'CreditCheckForm.FurtherInformation.TotalText',
    defaultMessage: 'Totaal',
  },
});

export const errorMessages = defineMessages({
  requiredValue: {
    id: 'CreditCheckForm.Errors.required',
    defaultMessage: 'Dit veld is verplicht',
  },
  invalidNumber: {
    id: 'CreditCheckForm.Errors.invalidNumber',
    defaultMessage: 'Voer een geldig nummer in',
  },
  minValue: {
    id: 'CreditCheckForm.Errors.minValue',
    defaultMessage: 'De waarde is te laag',
  },
  maxValue: {
    id: 'CreditCheckForm.Errors.maxValue',
    defaultMessage: 'De waarde is te hoog',
  },
  invalidEnumValue: {
    id: 'CreditCheckForm.Errors.enumValue',
    defaultMessage: 'Ongeldige waarde geselecteerd',
  },
});
export const furtherInformationMessages = defineMessages({
  cardTitle: {
    id: 'CreditCheckForm.FurtherInformationCard.CardTitle',
    defaultMessage: 'Meer informatie',
  },
  monthlyIncome: {
    id: 'CreditCheckForm.FurtherInformationCard.MonthlyIncome',
    defaultMessage: 'Wat is je netto maandinkomen *',
  },
  monthlyIncomeDialogText: {
    id: 'CreditCheckForm.FurtherInformationCard.MonthlyIncomeDialogText',
    defaultMessage:
      'Het netto-inkomen is het bedrag dat je elke maand overhoudt. Dat kan dus je inkomen uit loondienst zijn, je uitkering of je gemiddelde maandinkomen als zzp’er. Het netto-inkomen kan ook een combinatie van inkomsten zijn, als je bijvoorbeeld naast je baan bij een werkgever ook als zzp’er inkomsten hebt. Krijg je een maandelijks een bonus, dan mag je ook dat bedrag meenemen. Wisset het bedrag van je bonus, dan gebruik je het bedrag dat je jaarlijks als bonus ontvangt en deel je het bedrag door 12 maanden. En heb je bijvoorbeeld ook inkomsten uit een huis dat je verhuurt, kapitaal dat je belegt, of krijg je alimentatie, dan mag je ook dat bedrag meenemen. Je moet wel rekening houden met de bestendigheid van je inkomen. {break}{break}<strong>Bestendigheid van je inkomen</strong> {break} Het is belangrijk dat je inkomen bestendig is. Daar bedoelen we mee, dat je geen loon mag meetellen dat je krijgt van een werkgever waar je een tijdelijk contract hebt. Of een werkgever waar je binnenkort niet meer werkt. Alleen als je inkomen nog minimaal 6 maanden gegarandeerd is, of als je contract verlengen met minimaal 6 maanden, mag je dit inkomen meenemen. Heb je bijvoorbeeld een vaste parttime baan en daarnaast nog een uitzendbaan voor twee maanden, dan mag je alleen het inkomen van je vaste parttime baan meenemen.',
  },
  savingsRetirementQuestion: {
    id: 'CreditCheckForm.FurtherInformationCard.SavingsRetirementQuestion',
    defaultMessage: 'Bouw je pensioen op en/of spaar je hier zelf voor? *',
  },
  savingsRetirmentDialogText: {
    id: 'CreditCheckForm.FurtherInformationCard.SavingsRetirementDialogText',
    defaultMessage:
      'Als je geen pensioen opbouwt en hier zelf ook niet voor spaart, heeft dit invloed op je financiële situatie en zijn we wettelijk verplicht om deze informatie mee te nemen in onze kredietberekening.',
  },
  automobileQuestion: {
    id: 'CreditCheckForm.FurtherInformationCard.AutomobileQuestion',
    defaultMessage: 'Heb je een eigen auto? *',
  },
  automobileDialogText: {
    id: 'CreditCheckForm.FurtherInformationCard.AutomobileDialogText',
    defaultMessage:
      'Je hoeft hier alleen aan te geven of je zelf minstens 1 auto in je bezit hebt. Als je alleen een zakelijke leaseauto (dus van je werkgever) rijdt en geen eigen auto hebt, vul je hier ‘nee’ in. Als je een eigen auto bezit dan heeft dit invloed op je financiële situatie en daar moeten we rekening mee houden bij het verstrekken van krediet.',
  },
  automobileFollowUpQuestion: {
    id: 'CreditCheckForm.FurtherInformationCard.AutomobileFollowUpQuestion',
    defaultMessage: 'Is je auto volledig afbetaald? *',
  },
  automobileFollowUpDialogText: {
    id: 'CreditCheckForm.FurtherInformationCard.AutomobileFollowUpDialogText',
    defaultMessage:
      'Als je een eigen auto hebt dan zijn daar extra kosten mee gemoeid. Dit heeft invloed op je financiële situatie en daar moeten we rekening mee houden bij het verstrekken van krediet. Wij vragen niet om de precieze kosten van je auto, maar we gebruiken gemiddelde kosten voor onze berekening. Je vult ‘ja’ in als je een auto in je bezit hebt die volledig is afbetaald. Als je auto nog niet volledig is afbetaald of een private lease auto is, vul je ‘nee in’. Als je meerdere auto’s heb en tenminste 1 van je auto’s is volledig afbetaald, vul je ‘ja’ in.',
  },
  childDayCareQuestion: {
    id: 'CreditCheckForm.FurtherInformationCard.ChildDayCareQuestion',
    defaultMessage: 'Maak je gebruik van kinderdagopvang? *',
  },
  childDayCareDialogText: {
    id: 'CreditCheckForm.FurtherInformationCard.ChildDayCareQuestionDialogText',
    defaultMessage:
      'Als je gebruik maakt van betaalde kinderopvang heeft dit invloed op je financiële situatie en zijn we wettelijk verplicht dit mee te nemen in onze kredietberekening. ',
  },
  furtherInformationCardLink: {
    id: 'CreditCheckForm.FurtherInformationCard.FurtherInformationCardLink',
    defaultMessage: 'Uitgebreide toelichting',
  },
  incomeDescription: {
    id: 'CreditCheckForm.FurtherInformationCard.IncomeDescription',
    defaultMessage:
      'Het netto-inkomen is het bedrag dat je elke maand overhoudt. Dat kan dus je inkomen uit loondienst zijn, je uitkering of je gemiddelde maandinkomen als zzp’er. Het netto-inkomen kan ook een combinatie van inkomsten zijn, als je bijvoorbeeld naast je baan bij een werkgever ook als zzp’er inkomsten hebt. Krijg je een maandelijks een bonus, dan mag je ook dat bedrag meenemen. Wisselt het bedrag van je bonus, dan gebruik je het bedrag dat je jaarlijks als bonus ontvangt en deel je het bedrag door 12 maanden. En heb je bijvoorbeeld ook inkomsten uit een huis dat je verhuurt, kapitaal dat je belegt, inkomen uit een levensverzekering, zoals lifrenten of krijg je alimentatie, dan mag je ook die bedragen meenemen. Je moet wel rekening houden met de bestendigheid van je inkomen',
  },
});
export const creditFormMessages = defineMessages({
  wontDiscloseInformation: {
    id: 'CreditCheckForm.InformationDisclosure',
    defaultMessage: 'Ik wil deze informatie niet prijsgeven',
  },
  nextButton: {
    id: 'CreditCheckForm.NextButton',
    defaultMessage: 'Verder',
  },
  continueWithFormButton: {
    id: 'CreditCheckForm.ContinueWithFormButton',
    defaultMessage: 'Gegevens invullen',
  },
  returnButton: {
    id: 'CreditCheckForm.ReturnButton',
    defaultMessage: 'Andere betaalmethode',
  },
  creditAgreementInfoHeadline: {
    id: 'CreditCheckForm.CreditAgreementInfoHeadline',
    defaultMessage: 'Kredietovereenkomst',
  },
  creditAgreementInfoText: {
    id: 'CreditCheckForm.CreditAgreementInfoText',
    defaultMessage:
      'OTTO heeft de plicht ervoor te zorgen dat je betalingsverplichtingen binnen je budget passen. Daarom stellen we je enkele vragen over je thuissituatie en vaste lasten. Beantwoording van onderstaande vragen leidt tot een (nieuwe) kredietovereenkomst, waarin wij de met jou afgesproken limiet vermelden. Deze limiet wordt binnen een maand ook bij het Bureau Krediet Registratie (BKR) in Tiel gemeld.',
  },
  creditContractHeadline: {
    id: 'CreditCheckForm.CreditContractHeadline',
    defaultMessage: 'Kredietovereenkomst',
  },
  creditContractText: {
    id: 'CreditCheckForm.CreditContractText',
    defaultMessage:
      'Nach diesem Kauf beträgt Ihre monatliche Rate {amount}. Können Sie das bezahlen? *',
  },
  creditInformationLabel: {
    id: 'CreditCheckForm.creditInformationLabel',
    defaultMessage: 'Ich habe die Kreditinformationen gelesen und akzeptiere diese.',
  },
  creditInformationDialogTrigger: {
    id: 'CreditCheckForm.creditInformationDialogTrigger',
    defaultMessage: 'Zu den Kreditinformationen',
  },
  creditInformationDialogHeadline: {
    id: 'CreditCheckForm.creditInformationDialogHeadline',
    defaultMessage: 'Kreditinformationen',
  },
  bkrInfoLink: {
    id: 'CreditCheckForm.BkrInfoLink',
    defaultMessage: 'Meer informatie',
  },
  bkrDialogTitle: {
    id: 'CreditCheckForm.BkrDialogTitle',
    defaultMessage: 'Wat is een BKR-registratie?',
  },
  bkrDialogText: {
    id: 'CreditCheckForm.BkrDialogText',
    defaultMessage:
      'Het BKR registreert alle doorlopende en aflopende leningen en kredieten met een limiet hoger dan € 250 en alle betaalrekeningen met de mogelijkheid tot roodstand van meer dan € 250. Deze registraties worden positieve registraties genoemd. Ook verhogingen of verlagingen op zo’n limiet worden gemeld. Zodra op een positieve registratie een achterstand ontstaat van meer dan twee maanden, wordt dat een negatieve registratie genoemd. Daarmee heeft het BKR een overzicht van iedereen die een of meerdere kredietmogelijkheden tot zijn beschikking heeft.{break}{break}Voordat je een lening of krediet afsluit, is de verstrekkende partij verplicht je bij het BKR te toetsen. Zo wordt inzichtelijk of je al verplichtingen uit lopende kredieten of leningen hebt en of er betalingsachterstanden zijn. Dat helpt de kredietverstrekker bij het nemen van een beslissing. De kredietgever is namelijk verplicht ervoor te zorgen dat je niet overgecrediteerd raakt. Zo word je als kredietaanvrager dus ook beschermd.{break}{break}Meer informatie vind je op onze servicepagina’s of op de website van het BKR (www.bkr.nl).',
  },
  dataCollectionDialogTitle: {
    id: 'CreditCheckForm.DataCollectionDialogTitle',
    defaultMessage: 'Belangrijke informatie',
  },
  dataCollectionDialogContent: {
    id: 'CreditCheckForm.DataCollectionDialogText',
    defaultMessage:
      'OTTO heeft de plicht ervoor te zorgen dat je betalingsverplichtingen binnen je budget passen. Zonder jouw gegevens kunnen we dit niet beoordelen en kun je jouw bestelling helaas niet in termijnen betalen.Wanneer je deze gegevens niet wil prijsgeven, kun je een andere betaalmethode kiezen op de betaalpagina.',
  },
  requiredHint: {
    id: 'CreditCheckForm.RequiredHint',
    defaultMessage: '* Deze velden moeten worden ingevuld',
  },
});
